import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";
import { DialogContextType } from "../../DialogComponents/FullScreenDialog";
import { useAddProxyServiceContext } from "../components/AddProxyServiceProvider";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();
  const { serviceType } = useAddProxyServiceContext();

  return useMemo(
    () => ({
      title: {
        text: styledHeaderText(
          t("addProxyService.addService", { ns: "dialogs" }).replace("{serviceType}", serviceType),
        ),
        icon: "externalservice",
      },
      meta: {
        aliasLabel: t("addProxyService.serviceName", { ns: "dialogs" }),
        descriptionLabel: t("addProxyService.description", { ns: "dialogs" }),
        loaderLabel: t("addProxyService.imageForCatalog", { ns: "dialogs" }),
      },
      attributes: {
        label: t("addProxyService.layers", { ns: "dialogs" }),
        description: t("addProxyService.chooseProxyLayers", { ns: "dialogs" }),
        icon: "layers",
      },
      applyText: t("actions.create", { ns: "common" }),
    }),
    [t, serviceType],
  );
};
